<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-xl-12">
          <div
            class="card card-custom bg-transparent shadow-none border-0 mb-0"
          >
            <div class="card-header align-items-center border-bottom-dark px-0">
              <div class="card-title mb-0">
                <h3 class="card-label mb-0 font-weight-bold text-body">
                  Manage Gallery
                </h3>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>



      <div class="row">
        <div class="col-12">

          <div class="d-flex align-items-center mb-3">
            <h3 class="card-label mb-0 font-weight-bold text-body mr-3">{{ tagSearch ? 'Search Results' : 'Main Folder' }}</h3>
            <input type="text" class="form-control" v-model="tagSearch"
              placeholder="Search tag..." style="width: 220px;" />
            <button v-if="tagSearch !== ''" class="btn btn-sm btn-secondary ml-1"
              @click="tagSearch = ''">Clear</button>
          </div>



          <div class="gallary-categories">
            <ul
              class="nav nav-pills justify-content-start mb-0"
              id="pills-tab"
              role="tablist"
            >
           
              <li class="nav-item" v-for="tag in filteredParentTags">
                <a
                  class="nav-link btn-light-dark shadow-none mr-4 mb-4"
                  :class="{ active: tag_id == tag.tag_id }"
                  id="general-tab-center"
                  data-toggle="pill"
                  :href="'#' + tag.tag_name"
                  role="tab"
                  aria-controls="general"
                  aria-selected="false"
                  @click="getChildTag(tag.tag_id,tag.tag_name)"
                >
                  {{ tag.tag_name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>





      <div class="row" v-if="child_tags.length > 0 && !tagSearch">
        <div class="col-12">

          <div class="card-title mb-0">
                <h3 class="card-label mb-0 font-weight-bold text-body">
                  {{ tag_name_select }}
                </h3>
              </div>



          <div class="gallary-categories">
            <ul
              class="nav nav-pills justify-content-start mb-0"
              id="pills-tab"
              role="tablist"
            >
             
              <li class="nav-item" v-for="tag in child_tags">
                <a
                  class="nav-link btn-light-dark shadow-none mr-4 mb-4"
                  :class="{ active: tag_id == tag.tag_id }"
                  id="general-tab-center"
                  data-toggle="pill"
                  :href="'#' + tag.tag_name"
                  role="tab"
                  aria-controls="general"
                  aria-selected="false"
                  @click="getChildTag(tag.tag_id,tag.tag_name)"
                >
                  {{ tag.tag_name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>





























      <div class="row">
        <div class="col-12">
          <div
            id="generalgallary"
            class="gallary0 linked card card-custom gutter-b bg-white border-0"
          >
            <div class="card-header border-0 align-items-center">
              <fieldset>
                <div class="checkbox d-flex align-items-center">
                  <input
                    type="checkbox"
                    class="checkbox-input"
                    id="checkbox1"
                    @change="check($event)"
                  />
                  <label for="checkbox1">
                    Select All
                    <small class="text-muted"
                      >({{ this.selectedImages.length }} Item Selected)</small
                    ></label
                  >
                </div>
              </fieldset>
              <div class="icons d-flex">
                <button
                  type="button"
                  class="btn btn-danger p-2 ml-2"
                  title="Delete"
                  id="confirm-color"
                  @click="deletegallary()"
                >
                  Delete
                </button>

                <button
                  type="button"
                  title="Add New Image"
                  class="btn btn-primary white p-2 ml-2"
                  data-toggle="modal"
                  data-target="#imagepopup"
                  @click="toggleModal()"
                >
                  Add New Image
                </button>

                <button
                  type="button"
                  title="Add New Tag"
                  class="btn btn-primary white p-2 ml-2"
                  data-toggle="modal"
                  data-target="#tagpopup"
                  @click="toggleModal1()"
                >
                  Add New Tag
                </button>







                <!--Basic Modal -->
                <div class="modal fade text-left"
                  :class="{ show: showModal }"
                  id="imagepopup"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myModalLabel1"
                  :style="[
                    showModal
                      ? { display: 'block !important' }
                      : { display: 'none' },
                  ]"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h3 class="modal-title" id="myModalLabel1">
                          Add File Here
                        </h3>
                        <button
                          type="button"
                          class="
                            close
                            rounded-pill
                            btn btn-sm btn-icon btn-light btn-hover-primary
                            m-0
                          "
                          data-dismiss="modal"
                          aria-label="Close"
                          @click="toggleModal()"
                        >
                          <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 16 16"
                            class="bi bi-x"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <div class="modal-body">
                       <p>
                          Click in the box to upload images or videos. <br />
                          We accept: <strong>JPG, JPEG, PNG, GIF, WEBP, BMP, SVG</strong> for images, and <strong>MP4</strong> for videos.
                        </p>

                        <div class="avatar-upload mb-3">
                          <div class="avatar-edit">
                            <input
                              type="file"
                              id="imageUpload"
                              accept=".png, .jpg, .jpeg, .gif, .webp, .bmp, .svg, .mp4"
                              @change="onFileChange"
                            />

                            <label for="imageUpload"> image upload </label>
                          </div>
                          <div class="avatar-preview">
                            <div id="imagePreview" class="rounded">
                              <img
                                :src="url"
                                style="height: 194px; width: 100%"
                              />
                            </div>
                          </div>
                          <small
                            class="form-text text-danger"
                            v-if="errors.has('file')"
                            v-text="errors.get('file')"
                          ></small>
                        </div>
                        <fieldset class="form-group">
                          <label for="tags">Tag</label>
                          <select v-model="tag_id" style="width: 100%; height: 50px;">
                          <option v-for="tag in ch_tags" :key="tag.tag_id" :value="tag.tag_id">
                            {{ tag.tag_name }}
                          </option>
                            </select>
                        </fieldset>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-light"
                          data-dismiss="modal"
                          @click="toggleModal()"
                        >
                          <span class="">Close</span>
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary ml-1"
                          data-dismiss="modal"
                          @click="addUpdategallary()"
                        >
                          <span class="">Submit</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>




















          <!----add new tag-->
          <div class="modal fade text-left"
                  :class="{ show: showModal1 }"
                  id="tagpopup"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myModalLabel2"
                  :style="[
                    showModal1
                      ? { display: 'block !important' }
                      : { display: 'none' },
                  ]"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h3 class="modal-title" id="myModalLabel2">
                          Add Tag Here
                        </h3>
                        <button
                          type="button"
                          class="
                            close
                            rounded-pill
                            btn btn-sm btn-icon btn-light btn-hover-primary
                            m-0
                          "
                          data-dismiss="modal"
                          aria-label="Close"
                          @click="toggleModal1()"
                        >
                          <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 16 16"
                            class="bi bi-x"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <div class="modal-body">

                        <fieldset class="form-group">
                          <label for="tags">Parent Tags</label>
                          <select v-model="parent_tag" style="width: 100%; height: 50px;">
                          <option v-for="tag in tags_not_have_gallary" :key="tag.tag_id" :value="tag.tag_id">
                            {{ tag.tag_name }}
                          </option>
                            </select>
                        </fieldset>




                        <fieldset class="form-group">
                          <label for="tags">Tags</label>
                          <input type="text" v-model="new_tag" style="width: 100%;height: 50px;">
                        </fieldset>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-light"
                          data-dismiss="modal"
                          @click="toggleModal1()"
                        >
                          <span class="">Close</span>
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary ml-1"
                          data-dismiss="modal"
                          @click="addNewTag()"
                        >
                          <span class="">Submit</span>
                        </button>
                      </div>



                    </div>
                  </div>
                </div>
              </div>
            </div>







            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="All-center"
                role="tabpanel"
                aria-labelledby="All-tab-center"
              >
                <div class="card-body">
                  <div class="row">
                    <div
                      v-for="gallary in gallaries"
                      class="
                        col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3
                        loadingmore
                      "
                      style="display: block"
                      @click="setSelectedImages(gallary.id)"
                    >
                      <div
                        class="thumbnail text-center mb-4"
                        :class="{ active: selectedImages.includes(gallary.id) }"
                      >
                        <div class="detail-link">
                          <router-link
                            :to="'/admin/media/' + gallary.id"
                            class="
                              btn btn-link
                              d-flex
                              justify-content-center
                              align-items-center
                              flex-column
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              x="0px"
                              y="0px"
                              width="512px"
                              height="512px"
                              viewBox="0 0 512 512"
                              enable-background="new 0 0 512 512"
                              xml:space="preserve"
                            >
                              <g>
                                <g>
                                  <g>
                                    <path
                                      d="M508.745,246.041c-4.574-6.257-113.558-153.206-252.748-153.206     c-139.191,0-248.179,146.949-252.748,153.2c-4.332,5.936-4.332,13.986,0,19.923c4.569,6.257,113.557,153.206,252.748,153.206     c139.19,0,248.174-146.95,252.748-153.201C513.083,260.027,513.083,251.971,508.745,246.041z M255.997,385.406     c-102.529,0-191.33-97.533-217.617-129.418c26.253-31.913,114.868-129.395,217.617-129.395     c102.524,0,191.319,97.516,217.617,129.418C447.361,287.923,358.746,385.406,255.997,385.406z"
                                    ></path>
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path
                                      d="M255.997,154.725c-55.842,0-101.275,45.433-101.275,101.275s45.433,101.275,101.275,101.275     c55.842,0,101.274-45.434,101.274-101.275S311.839,154.725,255.997,154.725z M255.997,323.516     c-37.23,0-67.516-30.287-67.516-67.516c0-37.229,30.287-67.516,67.516-67.516c37.229,0,67.516,30.287,67.516,67.516     C323.513,293.229,293.227,323.516,255.997,323.516z"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </svg>
                            View Detail
                          </router-link>
                        </div>
                        <div class="thumbnail-imges">

                          <div v-if="gallary.detail.length > 0">
            <div v-if="gallary.gallary_extension === 'video/mp4'">

              <a
                            class="img-select d-block"
                            href="javascript:void(0);"
                          >
                <video 
                :src="cdnUrl('/gallary/' + gallary.gallary_name)"
                    class="img-fluid border-radius-10px w-100" 
                    controls 
                    alt="video"
                ></video>
                </a>
            </div>
            <div v-else>

              <a
                            class="img-select d-block"
                            href="javascript:void(0);"
                          >
                <img 
                :src="cdnUrl('/gallary/' + gallary.gallary_name)"
                    class="img-fluid border-radius-10px w-100" 
                    alt="actual image"
                />
                </a>
            </div>
        </div>
    </div>

                          
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <nav aria-label="navigation">
                        <div
                          class="
                            pagination
                            d-flex
                            justify-content-end
                            align-items-center
                          "
                        >
                          <div class="mr-2 text-dark">
                            (Showing result
                            <span id="numbering">{{ meta.to }}</span> out of
                            <span id="totalnumber">{{ meta.total }}</span> )
                          </div>
                          <a
                            class="btn btn-secondary white"
                            href="#"
                            id="loadMore"
                            @click="setLimit()"
                            >Load More</a
                          >
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";

export default {
  data() {
    return {
      meta: {},
      limit: 20,
      error_message: "",
      edit: false,
      actions: false,
      pagination: {},
      request_method: "",
      gallaries: [],
      tags: [],
      parent_tags: [],
      child_tags: [],
      ch_tags:[],
      parent_tag:"",
      new_tag:"",
      tag_id: "",
      tags_not_have_gallary:"",
      tagSearch: "",
      tag_name_select: " ",
      token: [],
      selectedImages: [],
     supported_extension: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "webp",
        "bmp",
        "svg",
        "mp4",
      ],

      file: [],
      gallary_tags: [],
      showModal: false,
      url: "/default.png",
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },

  methods: {
    check: function (e) {
      if (e.target.checked) {
        this.selectedImages = [];
        for (var i = 0; i < this.gallaries.length; i++) {
          this.selectedImages.push(this.gallaries[i].id);
        }
      } else {
        this.selectedImages = [];
      }
    },
    setSelectedImages(gallary_id) {
      console.log(gallary_id);
      if (this.selectedImages.includes(gallary_id)) {
        const index = this.selectedImages.indexOf(gallary_id);
        if (index > -1) {
          this.selectedImages.splice(index, 1);
        }
      } else {
        this.selectedImages.push(gallary_id);
      }
    },
    fetchtags() {
      axios.get("/api/admin/tag?not_have_gallary=1", this.token).then((res) => {
        this.tags_not_have_gallary = res.data.data;
      });
    },
    fetch_tags_not_have_gallry() {
      axios.get("/api/admin/tag?not_have_gallary=1&sortBy=id&sortType=DESC", this.token).then((res) => {
        this.tags = res.data.data;
      });
    },
    fetch_parent_tags() {
      axios.get("/api/admin/tag?parent=1", this.token).then((res) => {
        this.parent_tags = res.data.data;
      });
    },
    fetch_child_tags() {
      axios.get("/api/admin/tag?child=1&sortBy=id&sortType=DESC", this.token).then((res) => {
        this.ch_tags = res.data.data;
      });
    },
    gallaryByTagId(tag_id) {
      this.tag_id = tag_id;
      this.fetchgallaries();
    },
    getChildTag(tag_id, tag_name) {
        this.tag_name_select = tag_name;
        axios.get("/api/admin/tag?childOf=" + tag_id, this.token)
            .then((res) => {
                if (res.data.data.length > 0) {
                    this.child_tags = res.data.data;
                } else {
                    this.gallaryByTagId(tag_id);
                }
            })
            .catch((error) => {
                console.error('Error fetching child tags:', error);
            });
    },
    fetchgallaries() {
      this.$parent.loading = true;
      let vm = this;
      var page_url = page_url || "/api/admin/gallary";
      var arr = page_url.split("?");

      if (arr.length > 1) {
        page_url += "&limit=" + this.limit;
      } else {
        page_url += "?limit=" + this.limit;
      }
      if (this.tag_id != null) {
        page_url += "&tag_id=" + this.tag_id;
      }
      page_url += "&getDetail=1&getGallaryTag=1&sortBy=id&sortType=DESC";
      var responseData = {};

      axios
        .get(page_url, this.token)
        .then((res) => {
          this.gallaries = res.data.data;
          this.meta = res.data.meta;
        })
        .finally(() => (this.$parent.loading = false));
    },
    deletegallary() {
      var token = localStorage.getItem("token");
      if (this.selectedImages.length > 0) {
        if (confirm("Are You Sure?")) {
          this.$parent.loading = true;
          axios
            .delete(`/api/admin/gallary`, {
              data: {
                id: this.selectedImages,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.selectedImages = [];
                this.$toaster.success(res.data.message);
                this.fetchgallaries();
              } else {
                this.$toaster.error(res.data.message);
              }
            })
            .catch((error) => {
              if (error.response.status == 422) {
                if (error.response.data.status == "Error") {
                  this.$toaster.error(error.response.data.message);
                }
              }
            })
            .finally(() => (this.$parent.loading = false));
        }
      }else{
            this.$toaster.error("Please Select Atleast One Image To Delete");
        }
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      // this.createImage(files[0]);
      var fileName = files[0].name;
      var re = /(?:\.([^.]+))?$/;
      // Cameras and phones save "IMG_1234.JPG" - compare the extension case-insensitively.
      var ext = (re.exec(fileName)[1] || "").toLowerCase();
      if (this.supported_extension.indexOf(ext) == -1) {
        this.$toaster.error("Only image files (JPG, JPEG, PNG, GIF, WEBP, BMP, SVG) and MP4 videos are supported.");
        return;
      }
      this.file = files[0];

      this.url = URL.createObjectURL(files[0]);
    },
    addUpdategallary() {
      this.$parent.loading = true;
      var url = "/api/admin/gallary";
      this.request_method = "post";
      var formData = new FormData();
      formData.append("file", this.file);
      formData.append("tag_id", this.tag_id);

      


      axios[this.request_method](url, formData, this.token)
        .then((res) => {
          if (res.data.status == "Success") {
            this.$toaster.success(res.data.message);
            this.clearForm();
            this.fetchgallaries();
            this.fetchtags();
            this.fetch_tags_not_have_gallry();
            this.fetch_parent_tags();
            this.fetch_child_tags();
          } else {
            this.$toaster.error(res.data.message);
          }
        })
        .catch((error) => {
          this.error_message = "";
          this.errors = new ErrorHandling();
          var response = error.response;
          if (response && response.status == 422 && response.data.status != "Error") {
            this.errors.record(response.data.errors);
            this.$toaster.error(Object.values(response.data.errors || {}).flat()[0] || "The file was not accepted.");
            return;
          }
          // Anything else (too large, server error) used to fail silently: say why instead.
          var message = response && response.status == 413
            ? "This file is too large for the server. Please compress it and try again."
            : (response && response.data && response.data.message) || "Upload failed. Please try again.";
          this.error_message = message;
          this.$toaster.error(message);
        })
        .finally(() => (this.$parent.loading = false));
    },





    addNewTag() {
      this.$parent.loading = true;
      var url = "/api/admin/tag";
      this.request_method = "post";
    
      var new_tag = this.new_tag;
      var parent_tag = this.parent_tag;

      var data = {'name':new_tag,'parent':parent_tag}

      axios[this.request_method](url, data, this.token)
        .then((res) => {
          if (res.data.status == "Success") {
            this.$toaster.success(res.data.message);
            this.clearForm();
            this.fetchtags();
            this.fetch_tags_not_have_gallry();
            this.fetch_parent_tags();
            this.fetch_child_tags();
          } else {
            this.$toaster.error(res.data.message);
          }
        })
        .catch((error) => {
          this.error_message = "";
          this.errors = new ErrorHandling();
          if (error.response.status == 422) {
            if (error.response.data.status == "Error") {
              this.error_message = error.response.data.message;
            } else {
              this.errors.record(error.response.data.errors);
            }
          }
        })
        .finally(() => (this.$parent.loading = false));
    },















    clearForm() {
      this.showModal = false;
      this.showModal1 = false;
      this.file = "";
      this.gallary_tags = [];
      this.selectedImages = [];
      this.url = "/default.png";
    },
    sorting(sortBy) {
      this.sortBy = sortBy;
      this.sortType =
        this.sortType == "asc" || this.sortType == "ASC"
          ? (this.sortType = "desc")
          : (this.sortType = "asc");
      this.fetchgallaries();
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleModal1() {
      this.showModal1 = !this.showModal1;
    },
    setLimit() {
      var limit = this.limit;
      this.limit = limit + 10;
      this.fetchgallaries();
    },
  },
  computed: {
    filteredParentTags() {
      if (!this.tagSearch) return this.parent_tags;
      const q = this.tagSearch.toLowerCase();
      const all = [...this.parent_tags, ...this.ch_tags];
      return all.filter(t => t.tag_name.toLowerCase().includes(q));
    },
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchgallaries();
    this.fetchtags();
    this.fetch_tags_not_have_gallry();
    this.fetch_parent_tags();
    this.fetch_child_tags();
  },
};
</script>
